import React, { type ReactElement, useMemo } from 'react'
import { PrimaryButton } from '../../components/Button'
import { InputLabel, OptionalLabel } from '../../components/Input'
import PageHeader from '../../components/PageHeader'
import PDFFileUpload from './PDFFileUpload'
import Tooltip from '../../components/Tooltip'
import { highlightInvalidFields } from '../../util/Util'

interface IProps {
  state: {
    formationDocument?: string
    formationDocumentUrl?: string
    formationDocumentFile?: File
    ownershipDocument?: string
    ownershipDocumentUrl?: string
    ownershipDocumentFile?: File
  }
  isSubmitting: boolean
  onUpdate: (value: Partial<IProps['state']>) => void
  onSubmit: () => void
}

const Documents = ({ state, isSubmitting, onUpdate, onSubmit }: IProps): ReactElement => {
  const isValid = useMemo(() => {
    return (!!state.formationDocument || !!state.formationDocumentUrl || !!state.formationDocumentFile) &&
      (!!state.ownershipDocument || !!state.ownershipDocumentUrl || !!state.ownershipDocumentFile)
  }, [state])

  return (<div style={{ display: 'flex', flexDirection: 'column', gap: 20, fontSize: 14, paddingBottom: 30 }}>
    <div style={{ marginBottom: 20 }}>
      <PageHeader title="Document submission" subTitle="Upload required documents for verification" />
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <InputLabel>
          Formation document
        </InputLabel>
        <OptionalLabel>PDF</OptionalLabel>
        <Tooltip message='Upload your certificate of formation or incorporation' />
      </div>
      <PDFFileUpload
        file={state.formationDocumentUrl ?? state.formationDocumentFile}
        onFile={f => onUpdate({ formationDocumentFile: f })}
        onRemove={() => {
          onUpdate({ formationDocumentUrl: undefined, formationDocumentFile: undefined })
        }} />
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <InputLabel>
          Ownership document
        </InputLabel>
        <OptionalLabel>PDF</OptionalLabel>
        <Tooltip message='Provide a signed document from a verified control person or regulatory authority listing all shareholders and their ownership percentages, ensuring the full 100% ownership is clearly accounted for.' />
      </div>
      <PDFFileUpload
        file={state.ownershipDocumentUrl ?? state.ownershipDocumentFile}
        onFile={f => onUpdate({ ownershipDocumentFile: f })}
        onRemove={() => {
          onUpdate({ ownershipDocumentUrl: undefined, ownershipDocumentFile: undefined })
        }} />
    </div>

    <PrimaryButton
      disabled={isSubmitting}
      isLoading={isSubmitting}
      onClick={() => {
        if (isValid) {
          onSubmit()
        } else {
          highlightInvalidFields()
        }
      }}>
      Continue
    </PrimaryButton>
  </div>
  )
}

export default Documents
